import React from "react";
import ProgramCard from "./ProgramCard";

const RecProgramCard = (props) => {
  return <ProgramCard {...props} badgeText="MOST RECOMMENDED" />;
};

export default RecProgramCard;
